/**
 * @format
 */
import { api } from '@/scripts/api';

export const GlobalCategoryService = {
    getAll(accountId, config = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    post(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${accountId}`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    delete(accountId, categoryId ) {
        return new Promise((resolve, reject) => {
            const service = `/ms/categories/v1/categories/${categoryId}/${accountId}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },
};
